module.exports = __webpack_public_path__ + "static/img/hyper-tube-wall-support_64.1c8ce9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-wall-support_64.png
// module id = gecD
// module chunks = 0